/**
 * Vue i18n Plugin
 * Integrates vue-i18n with language switching support
 */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zh from './lang/zh';
import en from './lang/en';
import vi from './lang/vi';

Vue.use(VueI18n);

const messages = {
  zh,
  en,
  vi
};

function getLocale() {
  const stored = localStorage.getItem('locale');
  if (stored && (stored === 'zh' || stored === 'en' || stored === 'vi')) {
    return stored;
  }
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang.startsWith('zh')) return 'zh';
  if (browserLang.startsWith('vi')) return 'vi';
  return 'vi';
}

const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: 'zh',
  messages,
  silentFallbackWarn: true,
  silentTranslationWarn: true
});

export function setLocale(locale) {
  if (locale === 'zh' || locale === 'en' || locale === 'vi') {
    i18n.locale = locale;
    localStorage.setItem('locale', locale);
    document.documentElement.setAttribute('lang', locale);
  }
}

export function getCurrentLocale() {
  return i18n.locale;
}

export function toggleLocale() {
  const order = ['zh', 'en', 'vi'];
  const idx = order.indexOf(i18n.locale);
  const newLocale = order[(idx + 1) % order.length];
  setLocale(newLocale);
  return newLocale;
}

export default i18n;
